(function () {
  'use strict';

  var ICONS = {
    lock:
      '<svg viewBox="0 0 24 24"><rect x="4.5" y="10.5" width="15" height="10" rx="1.8"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24"><rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 9h4l3 3v5h-7z"/><circle cx="6" cy="19" r="1.8"/><circle cx="17.5" cy="19" r="1.8"/></svg>',
    heart:
      '<svg viewBox="0 0 24 24"><path d="M12 20.5S3.5 15.4 3.5 9.4A4.4 4.4 0 0 1 12 7a4.4 4.4 0 0 1 8.5 2.4c0 6-8.5 11.1-8.5 11.1z"/></svg>',
    eye:
      '<svg viewBox="0 0 24 24"><path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    cart:
      '<svg viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M1.5 2.5h3l2.7 13.2a2 2 0 0 0 2 1.6h9a2 2 0 0 0 2-1.6L21.5 7H5.3"/></svg>',
    bag:
      '<svg viewBox="0 0 24 24"><path d="M6 8h12l1.2 12.5a1.5 1.5 0 0 1-1.5 1.5H6.3a1.5 1.5 0 0 1-1.5-1.5z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>'
  };

  function replaceTrustBadgeIcons() {
    var badges = document.querySelectorAll('.savraa-trust-badge');
    if (!badges.length) return;
    var order = ['lock', 'truck', 'heart'];
    badges.forEach(function (badge, i) {
      var label = badge.textContent.trim();
      var icon = ICONS[order[i]] || ICONS.lock;
      badge.innerHTML = icon + '<span>' + label + '</span>';
    });
  }

  function initToast() {
    var urgencyEl = document.querySelector('savraa-urgency');
    if (!urgencyEl || document.querySelector('.savraa-toast')) return;

    var vMin = parseInt(urgencyEl.dataset.viewersMin, 10) || 8;
    var vMax = parseInt(urgencyEl.dataset.viewersMax, 10) || 24;
    var cMin = parseInt(urgencyEl.dataset.cartMin, 10) || 6;
    var cMax = parseInt(urgencyEl.dataset.cartMax, 10) || 18;
    var sMin = parseInt(urgencyEl.dataset.soldMin, 10) || 15;
    var sMax = parseInt(urgencyEl.dataset.soldMax, 10) || 45;

    var names = ['Ahmed', 'Sara', 'Mohammed', 'Fatimah', 'Khalid', 'Noura', 'Faisal', 'Layla', 'Omar', 'Huda', 'Abdullah', 'Reem'];
    var cities = ['Riyadh', 'Jeddah', 'Dammam', 'Mecca', 'Medina', 'Khobar', 'Taif', 'Abha'];

    function rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function pick(arr) {
      return arr[rand(0, arr.length - 1)];
    }

    function buildMessages() {
      return [
        { icon: 'eye', text: rand(vMin, vMax) + ' people are viewing this right now' },
        { icon: 'bag', text: pick(names) + ' from ' + pick(cities) + ' just bought this' },
        { icon: 'cart', text: rand(cMin, cMax) + ' people added this to their cart today' },
        { icon: 'bag', text: rand(sMin, sMax) + ' sold in the last 48 hours' }
      ];
    }

    var toast = document.createElement('div');
    toast.className = 'savraa-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="savraa-toast__icon"></span>' +
      '<span class="savraa-toast__body">' +
      '<span class="savraa-toast__text"></span>' +
      '</span>' +
      '<button type="button" class="savraa-toast__close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(toast);

    var iconEl = toast.querySelector('.savraa-toast__icon');
    var textEl = toast.querySelector('.savraa-toast__text');
    var closeBtn = toast.querySelector('.savraa-toast__close');

    var stopped = false;
    var timers = [];

    function clearTimers() {
      timers.forEach(function (t) {
        clearTimeout(t);
      });
      timers = [];
    }

    closeBtn.addEventListener('click', function () {
      stopped = true;
      clearTimers();
      toast.classList.remove('is-visible');
    });

    var queue = [];
    var qi = 0;

    function nextMessage() {
      if (!queue.length || qi >= queue.length) {
        queue = buildMessages();
        qi = 0;
      }
      return queue[qi++];
    }

    function cycle() {
      if (stopped) return;
      var msg = nextMessage();
      iconEl.innerHTML = ICONS[msg.icon] || ICONS.eye;
      textEl.textContent = msg.text;
      toast.classList.add('is-visible');

      timers.push(
        setTimeout(function () {
          toast.classList.remove('is-visible');
          timers.push(setTimeout(cycle, rand(6000, 10000)));
        }, 4600)
      );
    }

    timers.push(setTimeout(cycle, 3200));
  }


  function initScrollReveal() {
    var targets = document.querySelectorAll('.savraa-desc, .savraa-spec-card');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    replaceTrustBadgeIcons();
    initToast();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
